/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from "react-simple-maps";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./dropdown-menu";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const locations = [
  { name: "Canada", coordinates: [-106.3468, 56.1304], percent: 71.1 },
  { name: "USA", coordinates: [-95.7129, 37.0902], percent: 67.0 },
  { name: "Brazil", coordinates: [-51.9253, -14.235], percent: 53.9 },
  { name: "Russia", coordinates: [105.3188, 61.524], percent: 49.2 },
  { name: "China", coordinates: [104.1954, 35.8617], percent: 38.8 },
];

const regions = ["Asia", "Europe", "North America"];

export default function SalesMapCard() {
  const [selectedRegion, setSelectedRegion] = useState("Asia");

  // Calculate the left position for each bar segment
  let left = 0;
  const barSegments = locations.map((loc, idx) => {
    const segment = (
      <div
        key={loc.name}
        className="h-full flex items-center justify-center text-xs font-semibold"
        style={{
          width: `${loc.percent}%`,
          background:
            "linear-gradient(135deg, hsl(151 65% 45%), hsl(151 65% 60%))",
          borderTopLeftRadius: idx === 0 ? 8 : 0,
          borderBottomLeftRadius: idx === 0 ? 8 : 0,
          borderTopRightRadius: idx === locations.length - 1 ? 8 : 0,
          borderBottomRightRadius: idx === locations.length - 1 ? 8 : 0,
        }}
      >
        <span className="w-full text-center text-white">{loc.percent}%</span>
      </div>
    );
    left += loc.percent;
    return segment;
  });

  return (
    <div className="bg-background border border-surface-2 text-white rounded-2xl p-6 w-1/2 max-w-3xl">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-primary dark:text-primary">
          Most Sales Location
        </h2>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-2 bg-background border border-surface-2 text-sm text-primary dark:text-primary rounded px-3 py-1 focus:outline-none">
              {selectedRegion}
              <ChevronDown size={16} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {regions.map((region) => (
              <DropdownMenuItem
                key={region}
                onClick={() => setSelectedRegion(region)}
              >
                {region}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      {/* Map */}
      <div className="relative w-full h-96 rounded-lg overflow-hidden">
        <ComposableMap
          projectionConfig={{
            scale: 200,
            center: [0, 30],
          }}
          className="w-full h-full"
        >
          <ZoomableGroup zoom={1}>
            <Geographies geography={geoUrl}>
              {({ geographies }) =>
                geographies.map((geo) => (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    style={{
                      default: {
                        fill: "#e8f5e8",
                        stroke: "#e8f5e8",
                        strokeWidth: 0.5,
                        outline: "none",
                      },
                      hover: {
                        fill: "#374151",
                        stroke: "#4B5563",
                        strokeWidth: 0.5,
                        outline: "none",
                      },
                      pressed: {
                        fill: "#4B5563",
                        stroke: "#6B7280",
                        strokeWidth: 0.5,
                        outline: "none",
                      },
                    }}
                  />
                ))
              }
            </Geographies>
            {locations.map(({ name, coordinates }) => (
              <Marker key={name} coordinates={coordinates as [number, number]}>
                <g transform="translate(-12, -24)">
                  <circle
                    r={10}
                    fill="text-primary dark:text-primary"
                    stroke="#a5b4fc"
                    strokeWidth={4}
                  />
                  <circle
                    r={6}
                    fill="text-primary dark:text-primary"
                    stroke="#fff"
                    strokeWidth={2}
                  />
                  <text
                    textAnchor="middle"
                    y={24}
                    style={{
                      fontFamily: "system-ui",
                      fill: "text-primary dark:text-primary",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    {name === "USA" ? "United States" : name}
                  </text>
                </g>
              </Marker>
            ))}
          </ZoomableGroup>
        </ComposableMap>
      </div>

      {/* Country Stats Bar */}
      <div className="mt-8">
        <div className="flex justify-between text-sm text-white/90 mb-2">
          {locations.map((loc) => (
            <span key={loc.name} className="w-1/5 text-center font-medium">
              {loc.name === "USA" ? "USA" : loc.name}
            </span>
          ))}
        </div>
        <div className="flex w-full h-8 rounded-lg overflow-hidden bg-[#232b38]">
          {barSegments}
        </div>
      </div>
    </div>
  );
}
